import {evite} from 'evite';
import XDate from '~js-lib/xdate';
import '~/common/libraries-react/index.js';

window.XDate = XDate;
evite.resolve('site-libraries');
